export default "__VITE_ASSET__B_RvJyy8__"